export default function EducationInfo({ education }) {
  if (!education) return null;

  return (
    <div
      style={{
        backgroundColor: 'var(--card-background, #fff)',
        borderRadius: 16,
        padding: '20px 24px',
        border: '1px solid var(--border-light, rgba(0,0,0,0.07))',
        boxShadow: 'var(--shadow-sm, 0 1px 6px rgba(0,0,0,0.05))',
      }}
    >
          <div style={{ fontSize: 14, fontWeight: 700, color: 'var(--heading-primary, #111827)', marginBottom: 12 }}>
            Education Details
          </div>

          {education.education.map((item, index) => (
            <div key={index} style={{ padding: '8px 0', marginBottom: 8 }}>
              <div style={{ display: 'flex', color: 'var(--text-secondary, #6B7280)', fontSize: 13 }}>
                <div style={{ flex: 1 }}>
                  {item.degree} ({item.stream})
                </div>
                <div>
                  {item.startYear} - {item.endYear || 'Present'}
                </div>
              </div>

              <div style={{ display: 'flex', fontSize: 13 }}>
                <div style={{ flex: 1, fontWeight: 500, color: 'var(--text-primary, #111827)' }}>
                  {item?.university?.name}
                </div>
                <div style={{ color: 'var(--text-secondary, #6B7280)' }}>
                  Score: <span style={{ fontWeight: 600, color: 'var(--text-primary, #111827)' }}>{item?.percentage}%</span>
                </div>
              </div>
            </div>
          ))}
    </div>
  );
}
